import { setupWorker } from 'msw/browser'

// TODO: Re-enable generated MSW handlers when Orval TypeScript compatibility is fixed
// For now, we'll use an empty handlers array or add manual handlers as needed

// Example of manual handlers (can be expanded as needed):
// import { http, HttpResponse } from 'msw';
//
// const manualHandlers = [
//   http.get('/api/learnings/', () => {
//     return HttpResponse.json({
//       academy: [
//         { id: 1, title: 'Mock Academy Course', description: 'A mock course for testing' }
//       ],
//       FAQ: [
//         { question: 'Mock Question?', answer: 'Mock Answer' }
//       ]
//     });
//   }),
// ];

const handlers: any[] = [
  // Add manual handlers here as needed
  // ...manualHandlers,
]

// Create the worker
export const worker = setupWorker(...handlers)
